import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import aboutSection1 from '../../assets/images/banner/section_01_banner_01.png';
import aboutSection1Mobile from '../../assets/images/banner/section_01_m_banner_01.png';
import aboutSection2 from '../../assets/images/banner/section_01_banner_02.png';
import aboutSection2Mobile from '../../assets/images/banner/section_01_m_banner_02.png';
import aboutSection3 from '../../assets/images/banner/section_01_banner_03.png';
import aboutSection3Mobile from '../../assets/images/banner/section_01_m_banner_03.png';
import aboutSection4 from '../../assets/images/banner/section_01_banner_04.png';
import aboutSection4Mobile from '../../assets/images/banner/section_01_m_banner_04.png';
import aboutSection5 from '../../assets/images/banner/section_01_banner_05.png';
import aboutSection5Mobile from '../../assets/images/banner/section_01_m_banner_05.png';
import aboutSection6 from '../../assets/images/banner/section_01_banner_06.png';
import aboutSection6Mobile from '../../assets/images/banner/section_01_m_banner_06.png';
import aboutSection7 from '../../assets/images/banner/section_01_banner_07.png';
import aboutSection7Mobile from '../../assets/images/banner/section_01_m_banner_07.png';
import arrowLeft from '../../assets/images/banner/banner_arrow_left.svg';
import arrowRight from '../../assets/images/banner/banner_arrow_right.svg';
import './AboutBanner.css'; // CSS 파일 임포트

// react-slick 타입 선언
declare module 'react-slick' {
  export interface SlickMethods {
    slickPrev(): void;
    slickNext(): void;
    slickGoTo(slideNumber: number): void;
  }
}

function AboutSection1() {
  const [isMobile, setIsMobile] = useState(false);
  const sliderRef = useRef<Slider & { slickPrev: () => void; slickNext: () => void }>(null);

  // 화면 크기에 따라 모바일 여부 결정
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    handleResize(); // 초기 로딩 시 실행
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // 이전 슬라이드로 이동
  const goPrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  // 다음 슬라이드로 이동
  const goNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  // 슬라이더 설정
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          dots: false
        }
      }
    ]
  };

  // 배너 데이터
  const banners = [
    {
      id: 1,
      image: aboutSection1,
      mobileImage: aboutSection1Mobile,
      alt: 'About Banner 1'
    },
    {
      id: 2,
      image: aboutSection2,
      mobileImage: aboutSection2Mobile,
      alt: 'About Banner 2'
    },
    {
      id: 3,
      image: aboutSection3,
      mobileImage: aboutSection3Mobile,
      alt: 'About Banner 3'
    },
    {
      id: 4,
      image: aboutSection4,
      mobileImage: aboutSection4Mobile,
      alt: 'About Banner 4'
    },
    {
      id: 5,
      image: aboutSection5,
      mobileImage: aboutSection5Mobile,
      alt: 'About Banner 5'
    },
    {
      id: 6,
      image: aboutSection6,
      mobileImage: aboutSection6Mobile,
      alt: 'About Banner 6'
    },
    {
      id: 7,
      image: aboutSection7,
      mobileImage: aboutSection7Mobile,
      alt: 'About Banner 7'
    }
  ];

  return (
    <section className="w-full pt-0 relative">
      <div className="banner-container">
        <Slider ref={sliderRef} {...settings} className="banner-slider">
          {banners.map((banner) => (
            <div key={banner.id} className="banner-slide">
              <img
                src={isMobile ? banner.mobileImage : banner.image}
                alt={banner.alt}
                className="w-full h-auto"
              />
            </div>
          ))}
        </Slider>

        {/* 화살표 버튼 - 모바일에서는 숨김 */}
        <button
          className="banner-slider-arrow absolute top-1/2 left-0 md:left-[2%] lg:left-[3%] transform -translate-y-1/2 z-10"
          onClick={goPrev}
          aria-label="Previous slide"
        >
          <img src={arrowLeft} alt="Previous" className="w-10 h-10 md:w-12 md:h-12" />
        </button>
        <button
          className="banner-slider-arrow absolute top-1/2 right-0 md:right-[2%] lg:right-[3%] transform -translate-y-1/2 z-10"
          onClick={goNext}
          aria-label="Next slide"
        >
          <img src={arrowRight} alt="Next" className="w-10 h-10 md:w-12 md:h-12" />
        </button>
      </div>
    </section>
  );
}

export default AboutSection1;